module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "google_su.aeff0ed2.svg";